import React from 'react'
import Resources from '../pages/Resources';


const Hardware = () => {
  return (
    <div>
        <Resources />
        hi
    </div>
  )
}

export default Hardware;